import axios from "axios";
import utils from "./utils";
import managedata from "./managedata";


function _isTableSaved() {
    let isTableList = utils.isSessionValid('table-list')
    if (isTableList) return isTableList
    else return false
}

function getTableById(id) {
    const tableList = _isTableSaved();
    if (tableList) {
        const table = tableList.find(table => table.ID === id);
        return table || [];
    }
    return [];
}


function _isShapeSaved() {
    let isShapeList = utils.isSessionValid('shape-list')
    if (isShapeList) return isShapeList
    else return false
}

async function getShapes() {
    let isValid = _isShapeSaved()
    if (!isValid) {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data: {},
            type: {act: 'tableShapeTypeList'}
        };
        return await managedata.sendData(data, false, 'sendBack')
            .then((response) => {
                utils.saveSession('shape-list', JSON.stringify(response.data))
                return response.data
            })
            .catch((error) => {
                console.error(error);
                return []
            });
    } else return isValid
}

async function getAllTables() {
    let isValid = _isTableSaved()
    if (!isValid) {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            data: {},
            type: {act: 'tablesList'}
        };
        return await managedata.sendData(data, false, 'sendBack')
            .then((response) => {
                utils.saveSession('table-list', JSON.stringify(response.data))
                return response.data
            })
            .catch((error) => {
                console.error(error);
                return []
            });
    } else return isValid
}

async function addTable(tableData){
    let data = {
        authentication: {
            key: utils.getToken(),
            businessToken: utils.getBusToken(),
        },
        data: tableData,
        type: {act: 'addTable'}
    };
    return await managedata.sendData(data, false, 'sendBack')
        .then((response) => {
            console.log(response)
            utils.saveSession('table-list', JSON.stringify(response.data))
            return response.data
        })
        .catch((error) => {
            console.error(error);
            return []
        });
}


export default {
    getAllTables,
    addTable,
    getTableById,
    getShapes
}